import type { ButtonHTMLAttributes } from 'react';
import {
  AppButtonContent,
  appButtonClassName,
  type AppButtonSharedProps,
} from './AppButton';

export type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'> &
  AppButtonSharedProps;

export function Button({
  title,
  icon,
  iconPosition = 'left',
  children,
  className,
  variant,
  type = 'button',
  ...buttonProps
}: ButtonProps) {
  return (
    <button {...buttonProps} className={appButtonClassName(className, variant)} type={type}>
      <AppButtonContent icon={icon} iconPosition={iconPosition}>
        {children ?? title}
      </AppButtonContent>
    </button>
  );
}
